/**
 * LP Verify: Fixed version to match HTML data attributes
 */

const LP_COOKIE_DEFAULT = 'lp_age_status';

function getLpStatus(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setLpStatus(name, days) {
  const expiry = days ? parseInt(days) * 24 * 60 * 60 : 365 * 24 * 60 * 60;
  document.cookie = `${name}=passed; path=/; max-age=${expiry}; SameSite=Lax`;
}

function handleLpInteraction(event) {
  // 1. Check if the clicked element is one of our buttons
  const confirmBtn = event.target.closest('[data-lp-action-confirm]');
  const denyBtn = event.target.closest('[data-lp-action-deny]');
  
  // 2. Find the parent container that holds all the data
  const container = (confirmBtn || denyBtn)?.closest('[data-lp-verify]');

  if (!container) return;

  // 3. Map the settings to match your HTML exactly
  const settings = {
    name: container.getAttribute('data-cookie-name') || LP_COOKIE_DEFAULT,
    days: container.getAttribute('data-cookie-days') || 365,
    passUrl: container.getAttribute('data-redirect-url') || '/',
    failUrl: container.getAttribute('data-under-21-url') || 'https://www.google.com'
  };

  if (confirmBtn) {
    event.preventDefault();
    console.log('Age Confirmed. Redirecting to:', settings.passUrl);
    setLpStatus(settings.name, settings.days);
    window.location.href = settings.passUrl;
  }

  if (denyBtn) {
    event.preventDefault();
    console.log('Age Denied. Redirecting to:', settings.failUrl);
    window.location.href = settings.failUrl;
  }
}

function initLpVerify() {
  document.addEventListener('click', handleLpInteraction);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLpVerify);
} else {
  initLpVerify();
}